export class ChartConfiguration {
    ChartConfigurationId: number;
    Header: string;
    YAxisHeader: string;
    ProcedureName: string;
    DefaultDateFrom: number;
    DefaultDateTo: number;
    ChartType: string;
}

export class Size {
    constructor(public Width: number, public Height: number) {
    }
}

export class ChartConfigurationWrapper {
    constructor(public Size: Size) {
    }

    Configuration: ChartConfiguration;
    Colors: string[];
}
